export default {"src":"/_next/static/media/heartIcon.ee7259a9.svg","height":22,"width":25,"blurWidth":0,"blurHeight":0};